// 教学班级
export const STU_LEARNINGPROGRESS = 'stu_learningprogress'
export const STU_ACTIVITYTAKE = 'stu_activitytake'
export const STU_ACTIVITYTIME = 'stu_activitytime'
export const STU_ATTENDANCE = 'stu_attendance'
export const STU_PREPAREWARNING = 'stu_preparewarning'
export const STU_JOBWARNING = 'stu_jobwarning'
export const STU_ACTIVITYWARNING = 'stu_activitywarning'
export const STU_EVALUATE = 'stu_evaluate'
export const STU_TEACHDETAIL = 'stu_teachdetail'
export const STU_INFORMATION = 'stu_information'


// WEBPACK FOOTER //
// ./src/store/effect/type.js